import { InsuranceList } from "./insurance-list"

const el = {
  root: document.querySelector<HTMLElement>('.modal'),
  modalInner: document.querySelector<HTMLElement>('.modal__inner'),
  close: document.querySelector<HTMLButtonElement>('.modal__close'),
  modalHeading: document.querySelector<HTMLElement>('.modal__heading'),
  modalContent: document.querySelector<HTMLElement>('.modal__content'),
  modalTriggerButtons: document.querySelectorAll<HTMLButtonElement>('.modal-trigger-button'),
}

export const Modal = {

  init(): void {
    if (!el.root || !el.modalInner) return
    Modal.handleCloseButton()
    el.modalTriggerButtons.forEach(target => target.addEventListener('click', Modal.onModalTriggerClick))
    el.root.addEventListener('click', () => Modal.close())
    el.modalInner.addEventListener('click', (e) => e.stopPropagation())
  },

  onModalTriggerClick: (e: Event & { target: HTMLButtonElement }) => {
    const {
      heading = '',
      title = '',
      text = '',
      buttonlink = '',
      buttontext = '',
      url = '',
      type = '',
      svg = '',
    } = e.target.dataset;


    if (type === 'insurance') {
      Modal.open({
        heading,
        content: InsuranceList.getContent({ ...e.target.dataset }),
      })
      return
    }

    Modal.open({
      heading,
      title,
      text,
      buttonLink: buttonlink,
      buttonText: buttontext,
      url,
      type,
      svg,
    })
  },

  open({
    heading = '',
    title = '',
    text = '',
    buttonLink = '',
    buttonText = '',
    url = '',
    type = '',
    svg = '',
    content = ''
  }): void {
    el.root.classList.add('modal--open')
    el.root.classList.add(`modal--${type}`)
    el.close.setAttribute('data-modal', type)

    el.modalHeading.innerHTML = heading
    el.modalContent.innerHTML = content || Modal.setContent({
      title,
      text,
      buttonLink,
      buttonText,
      url,
      svg,
    })

    document.body.style.overflow = 'hidden'
    if (url) Modal.handleYouTube(url, url.includes('autoplay'))
  },

  close(type: string = ''): void {
    el.root.classList.remove('modal--open')
    el.root.classList.remove(`modal--${type || el.close.getAttribute('data-modal') || ''}`)
    document.body.style.overflow = ''
    el.modalContent.innerHTML = ''
  },

  handleCloseButton(): void {
    if (!el.close) return
    el.close.addEventListener('click', (e: Event & { target: HTMLButtonElement }) => {
      Modal.close(e.target.dataset.type)
    })
  },

  handleYouTube(url: string, autoplay?: boolean): void {
    const video = document.querySelector<HTMLElement>('.modal__video')
    if (!video) return

    const youtube = 'https://www.youtube.com/embed/'
    const youtubeRegex = /(http:|https:)?\/\/(www\.)?(youtube.com|youtu.be)\/(watch)?(\?v=)?(\S+)?/
    const youtubeMobile = /(http:|https:)?\/\/(m\.)?(youtube.com|youtu.be)\/(watch)?(\?v=)?(\S+)?/
    const youtubePlaylist = /(http:|https:)?\/\/(?:www\.)?youtube\.com\/watch\?(?:&.*)*((?:v=([a-zA-Z0-9_\-]{11})(?:&.*)*&list=([a-zA-Z0-9_\-]{18}))|(?:list=([a-zA-Z0-9_\-]{18})(?:&.*)*&v=([a-zA-Z0-9_\-]{11})))(?:&.*)*(?:\#.*)*$/

    if (url) {
      const matchPlaylist = url.match(youtubePlaylist)
      const match = url.match(youtubeRegex)
      const matchMobile = url.match(youtubeMobile)
      let id
      let listID

      let params = ''
      if (!autoplay) params = '?enablejsapi=1'

      if (matchPlaylist) {
        id = matchPlaylist[3]
        listID = matchPlaylist[4]
        video.setAttribute('src', `${youtube}${id}?list=${listID}${params}`)
      }
      else if (match) {
        id = match[6];
        video.setAttribute('src', `${youtube}${id}${params}`)
      }
      else if (matchMobile) {
        id = matchMobile[6];
        video.setAttribute('src', `${youtube}${id}${params}`)
      }

      video.style.opacity = '1'
    }
  },

  setContent: ({ title = '', text = '', buttonLink = '', buttonText = '', url = '', svg = '' }): string => {
    const videoHtml = url ? `
      <div class="modal__video-container">
        <iframe
          src="" 
          frameborder="0" 
          class="modal__video modal__video--youtube" 
          allowfullscreen
          allow="autoplay; encrypted-media"
        ></iframe>
      </div>
    ` : ''
    const svgHtml = svg ? `<div class="modal__svg">${svg}</div>` : ''
    const titleHtml = title ? `<h2 class="modal__title">${title}</h2>` : ''
    const textHtml = text ? `<p class="modal__text">${text}</p>` : ''
    const buttonHtml = buttonLink && buttonText ? `
      <a href="${buttonLink}" class="button modal__button">
        <span class="button__text">${buttonText}</span>
      </a>
    ` : ''

    return `${videoHtml}${svgHtml}${titleHtml}${textHtml}${buttonHtml}`
  },
}

